import { getClient, API_CALL_CENTER, API_CALL_CENTER_SERVICE } from '../api';
import { Count, ProcessableContact } from '../dtos';
import { ReferenceType } from '../../../domain/types';

export interface CalendarEventsFilters {
  referenceId?: string,
  referenceType?: ReferenceType,
}

export interface MatchContactFilters {
  phoneNumber?: string,
  email?: string,
}

export async function getNextLeadContactsCount(): Promise<Count> {
  const client = await getClient();
  const { data } = await client.get<Count>(`${API_CALL_CENTER}/next-contact/count`);

  return data;
}

export async function getNextColdLeadContactsCount(): Promise<Count> {
  const client = await getClient();
  const { data } = await client.get<Count>(`${API_CALL_CENTER_SERVICE}/cold-lead/count`);

  return data;
}

export async function getNextLeadContact(): Promise<ProcessableContact | undefined> {
  const client = await getClient();
  const { data } = await client.get<ProcessableContact | undefined>(`${API_CALL_CENTER}/next-contact`);

  return data;
}

/* TODO refactor, introduce a param to get next processable contact by context
* lead, cold-lead, job-application
* hard-code cold lead waitng for refactor and other entities managed by erlang
*/
export async function getNextColdLeadContact(): Promise<ProcessableContact | undefined> {
  const client = await getClient();
  const { data } = await client.get<ProcessableContact | undefined>(`${API_CALL_CENTER_SERVICE}/cold-lead/next-contact`);

  return data;
}

export async function saveLeadContactCallBackDate(contactId: string, callBackDate: Date): Promise<void> {
  const client = await getClient();
  await client.post<void>(`${API_CALL_CENTER}/call-back/${contactId}`, {
    date: callBackDate.toISOString(),
  });
}

export async function saveLeadContactNoAnswer(contactId: string): Promise<void> {
  const client = await getClient();
  await client.post(`${API_CALL_CENTER}/no-answer/${contactId}`);
}

export async function saveColdLeadContactNoAnswer(contactId: string): Promise<void> {
  const client = await getClient();
  await client.post(`${API_CALL_CENTER_SERVICE}/cold-lead/no-answer/${contactId}`);
}

export async function saveColdLeadContactCallBack(contactId: string, callBackDate: Date): Promise<void> {
  const client = await getClient();
  await client.post(`${API_CALL_CENTER_SERVICE}/cold-lead/call-back/${contactId}`, {
    date: callBackDate.toISOString(),
  });
}
